<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/XcHSnZ/media/FC-9781398456518.jpg?1684515200478" alt="This image is the cover for the book Jasmine"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Jasmine
      </h1>
      <p class="bookDescription body article font2">
        <p>Roger Harvey decided to leave the crowded underground train at Balham station and take the bus the rest of the way to the old War Office in Whitehall. As he was exiting the train, a youth bumped into him, shoved a pink plastic carrier bag into his hand, and disappeared into the crowd. Just as Roger was about to reach the street, a young woman came rushing in the opposite direction, collided with him, and fell heavily to the ground, winded. He helped the girl to her feet and, feeling sorry for her, suggested they have a coffee at the coffee house next to the station. When their drinks arrived, the girl noticed the plastic carrier bag Roger was still holding and asked about it. Inside, Roger found several sheets covered in chemical formulas that the girl recognized as potentially hazardous. As a military intelligence officer working for a supposedly non-existent government security department, Roger decided that the girl, whose name he had learned was Jasmine, and the chemicals deserved investigation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Howard Ellis
      </h2>
      
      <p class="authorDescription body article">Born on the eve of the second world war, living in the Midlands, I can remember being wakened as Coventry was being bombed. The early hours of D day seeing the sky filled with aircraft heading for Normandy, the roar of the engines making the windows rattle. Spent five years in the RAF then drifted into the motor industry until retirement. Now living on the South Coast with a one tenth share of an ex fishing boat and trying to become a writer.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ceca298